import { Navigate, RouteObject } from 'react-router-dom';
import React from 'react';
import {
  BasicProfile,
  ConnectionsList,
  Credits,
  ProfileIDs,
  RepresentativesList,
} from 'app/components/Profile';
import { routes } from 'app/routing/routesConfig';

export const profileRoutes: RouteObject[] = [
  { path: routes.profileBasic.route, element: <BasicProfile /> },
  { path: routes.profileIDs.route, element: <ProfileIDs /> },
  { path: routes.profileCredits.route, element: <Credits /> },
  { path: routes.profileConnections.route, element: <ConnectionsList /> },
  {
    path: routes.profileRepresentatives.route,
    element: <RepresentativesList />,
  },
  { path: '*', element: <Navigate to={routes.profileBasic.path} replace /> },
];
